export default __webpack_public_path__ + "static/char-s-06-en-c3c9a33f8d78e5a6b6236796470ef8d3.png";